import React from 'react';
import { FormField, FormHelp, Label } from '@zillow/constellation-10';

import type { Section } from '../../../../models/index';
import YesAndNo from '../../../Widgets/YesAndNo';
import { CONDO_ASSOCIATION_RULES } from '../../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function CondoAssociationRules({ section, setSectionValues }: Props): JSX.Element {
  function onNoRules(): void {
    setSectionValues({
      [CONDO_ASSOCIATION_RULES.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesRules(): void {
    setSectionValues({
      [CONDO_ASSOCIATION_RULES.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  return (
    <FormField
      required
      label={<Label>Do any homeowners or condo association rules apply to the property?</Label>}
      control={
        <YesAndNo
          yesHandler={onYesRules}
          noHandler={onNoRules}
          yesActive={section.getFieldValue(CONDO_ASSOCIATION_RULES.FIELD_NAME.IS_ENABLED)}
        />
      }
      description={
        <FormHelp>
          You must provide the tenant copies of all homeowners or condo association rules and regulations before the
          lease is signed
        </FormHelp>
      }
    />
  );
}
